<div class="propero-home">
  <section id="home" class="ph-hero ph-hero--compact">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>
    <div class="ph-container ph-hero__content--centered">
      <div class="ph-hero__badge">
        <span class="ph-hero__badge-dot" aria-hidden="true"></span>
        {{ 'TODO_LISTS.HERO_EYEBROW' | translate }}
      </div>
      <h1 class="ph-hero__title">{{ 'TODO_LISTS.TITLE' | translate }}</h1>
      <p class="ph-hero__subtitle">{{ 'HOME.TODO_LISTS_TEXT' | translate }}</p>
      <div class="ph-hero__actions ph-hero__actions--centered">
        <a [href]="assistantHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--brand ph-btn--lg">
          {{ 'TODO_LISTS.CTA' | translate }}
        </a>
        <a href="#features" class="ph-btn ph-btn--outline ph-btn--lg">{{ 'TODO_LISTS.FEATURES_TITLE' | translate }}</a>
      </div>
    </div>
  </section>

  <section id="features" class="ph-section ph-section--muted">
    <div class="ph-container">
      <div class="ph-section__header ph-section__header--center">
        <h2 class="ph-section__title">{{ 'TODO_LISTS.FEATURES_TITLE' | translate }}</h2>
        <p class="ph-section__lead">{{ 'TODO_LISTS.FEATURES_LEAD' | translate }}</p>
      </div>

      <div class="ph-benefits-grid">
        <article *ngFor="let item of features" class="ph-benefit-card">
          <div class="ph-benefit-card__icon" aria-hidden="true"><i class="lni" [ngClass]="item.icon"></i></div>
          <h3 class="ph-benefit-card__title">{{ item.titleKey | translate }}</h3>
          <p class="ph-benefit-card__text">{{ item.textKey | translate }}</p>
        </article>
      </div>
    </div>
  </section>

  <section id="cta" class="ph-section">
    <div class="ph-container ph-container--narrow">
      <div class="ph-page-cta">
        <h2 class="ph-page-cta__title">{{ 'HOME.TODO_LISTS_TITLE' | translate }}</h2>
        <p class="ph-page-cta__text">{{ 'HOME.TODO_LISTS_TEXT' | translate }}</p>
        <div class="ph-page-cta__actions">
          <a [href]="assistantHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--brand ph-btn--lg">
            {{ 'TODO_LISTS.CTA' | translate }}
          </a>
          <a routerLink="/register" class="ph-btn ph-btn--outline ph-btn--lg">{{ 'HOME.CREATE_LISTS' | translate }}</a>
        </div>
      </div>
    </div>
  </section>

  <section id="related" class="ph-section ph-section--muted">
    <div class="ph-container">
      <div class="ph-section__header ph-section__header--center">
        <h2 class="ph-section__title">{{ 'TODO_LISTS.RELATED_TITLE' | translate }}</h2>
      </div>
      <div class="ph-tools__grid">
        <a *ngFor="let link of relatedLinks" [routerLink]="link.route" class="ph-tool-card">
          <div class="ph-tool-card__icon"><i class="lni" [ngClass]="link.icon"></i></div>
          <h3 class="ph-tool-card__title">{{ link.titleKey | translate }}</h3>
          <p class="ph-tool-card__text">{{ link.textKey | translate }}</p>
          <span class="ph-tool-card__cta">
            {{ 'HOME.LEARN_MORE' | translate }}
            <i class="lni lni-arrow-right" aria-hidden="true"></i>
          </span>
        </a>
      </div>
    </div>
  </section>
</div>
